import { render, staticRenderFns } from "./SiteGettingStarted.vue?vue&type=template&id=07e19757&"
import script from "./SiteGettingStarted.vue?vue&type=script&lang=js&"
export * from "./SiteGettingStarted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports